// extracted by mini-css-extract-plugin
export default {"cls1":"FacebookDisabledPage-cls1_h0w","cls2":"FacebookDisabledPage-cls2_VUV FacebookDisabledPage-cls1_h0w"};